import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
            <i className="ri-bookmark-3-line w-3.5 h-3.5 flex items-center justify-center" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {desc}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}